import { useEffect, useState } from 'react';
import { Input, Label, Select, Textarea } from '../ui/Input';
import { Button } from '../ui/Button';
import { api } from '../../lib/api';
import type { Service } from '@bharat-consultancy/shared';

export function SEOMetaEditor() {
  const [services, setServices] = useState<Service[]>([]);
  const [selectedId, setSelectedId] = useState('');
  const [form, setForm] = useState({ seoTitle: '', seoDescription: '' });
  const [status, setStatus] = useState<'idle' | 'saving' | 'saved' | 'error'>('idle');

  useEffect(() => {
    api.admin.services
      .list()
      .then((res) => setServices(res.services))
      .catch(() => setServices([]));
  }, []);

  useEffect(() => {
    const service = services.find((s) => s.id === selectedId);
    if (service) {
      setForm({ seoTitle: service.seoTitle ?? '', seoDescription: service.seoDescription ?? '' });
    }
  }, [selectedId, services]);

  async function handleSave() {
    if (!selectedId) return;
    setStatus('saving');
    try {
      await api.admin.content.updateSeo(selectedId, form);
      setStatus('saved');
    } catch {
      setStatus('error');
    }
  }

  return (
    <div className="rounded-lg border border-line bg-white p-4">
      <Label htmlFor="service-select">Select Service</Label>
      <Select id="service-select" value={selectedId} onChange={(e) => setSelectedId(e.target.value)}>
        <option value="">Choose a service...</option>
        {services.map((s) => (
          <option key={s.id} value={s.id}>
            {s.title}
          </option>
        ))}
      </Select>

      {selectedId && (
        <div className="mt-4 space-y-3">
          <div>
            <Label htmlFor="seoTitle">SEO Title</Label>
            <Input id="seoTitle" value={form.seoTitle} onChange={(e) => setForm({ ...form, seoTitle: e.target.value })} />
          </div>
          <div>
            <Label htmlFor="seoDescription">SEO Description</Label>
            <Textarea
              id="seoDescription"
              rows={3}
              value={form.seoDescription}
              onChange={(e) => setForm({ ...form, seoDescription: e.target.value })}
            />
          </div>
          <Button size="sm" onClick={handleSave} disabled={status === 'saving'}>
            {status === 'saving' ? 'Saving...' : 'Save SEO Metadata'}
          </Button>
          {status === 'saved' && <p className="text-sm text-ledger-green">Saved.</p>}
          {status === 'error' && <p className="text-sm text-red-600">Could not save. Please try again.</p>}
        </div>
      )}
    </div>
  );
}
